var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-date-picker',{attrs:{"locale":"fr","value":_vm.value},on:{"input":_vm.handleChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var inputValue = ref.inputValue;
var inputEvents = ref.inputEvents;
return [_c('input',_vm._g({staticClass:"form-control",class:{'border-danger': _vm.hasError},domProps:{"value":inputValue}},inputEvents))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }